import React, { useState } from 'react';
import { Footprints, Bell } from 'lucide-react';
import { SyncIndicator } from '../SyncIndicator';
import { useTheme } from '../ThemeProvider';
import ReminderPopup from '../ReminderPopup';

export const HomeHeader = () => {
  const { theme } = useTheme();
  const [reminderOpen, setReminderOpen] = useState(false);

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 ${theme.headerBg} ios-header border-none`} 
        style={{ paddingTop: 'max(16px, env(safe-area-inset-top, 16px))', border: 'none' }}
      >
        <div className="container mx-auto px-2 sm:px-4 py-2 sm:py-3 flex items-center justify-between max-w-full overflow-hidden">
          {/* Left: App Logo and Title */}
          <div className="flex items-center gap-1 sm:gap-3 flex-shrink-0 min-w-0">
            <div className="relative w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0">
              <div className="relative w-full h-full rounded-2xl bg-slate-900 border border-slate-700 flex items-center justify-center">
                <Footprints className="w-5 h-5 sm:w-6 sm:h-6 text-blue-400" />
              </div>
            </div>
            <h1 className="text-base sm:text-xl font-heading font-bold tracking-tight truncate">
              <span className="text-blue-400">Walking</span>
              <span className="text-slate-500"> & </span>
              <span className="text-amber-400">Nutrition</span>
            </h1>
            {/* Sync Status Indicator */}
            <div className="ml-1 sm:ml-4 sm:mr-2 flex-shrink-0">
              <SyncIndicator compact={true} showLabel={false} className="sm:scale-110" />
            </div>
          </div>
          
          {/* Right: Reminder button */}
          <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
            <button
              onClick={() => setReminderOpen(true)}
              className="relative w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-slate-800/60 border border-slate-700/50 flex items-center justify-center hover:bg-slate-700/60 transition-colors"
              data-testid="reminder-btn"
              aria-label="Reminders"
            >
              <Bell className="w-4 h-4 sm:w-5 sm:h-5 text-amber-400" />
            </button>
          </div>
        </div>
      </header>
      <ReminderPopup open={reminderOpen} onOpenChange={setReminderOpen} />
    </>
  );
};

export default HomeHeader;
